define( [
	"../Data"
], function( Data ) {
	"use strict";

	return new Data();
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/data/var/dataPriv.js
// module id = k/l/
// module chunks = 0 1